import React from 'react';
import { Link } from 'react-router-dom';

export const VendedorServicesGrid = ({ onStoreSellerCode }) => {
  return (
    <div className="bg-white rounded-2xl shadow-xl p-6 mb-8" data-testid="vendedor-services-card">
      <h2 className="text-xl font-bold text-gray-900 mb-4" data-testid="vendedor-services-title">O que posso ajudar você?</h2>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-testid="vendedor-services-grid">
        <Link
          to="/questionario-casas"
          className="border-2 border-blue-200 rounded-xl p-4 hover:border-blue-500 hover:bg-blue-50 transition text-center"
          onClick={onStoreSellerCode}
          data-testid="vendedor-service-casas-link"
        >
          <span className="text-4xl block mb-2">🏠</span>
          <div className="font-semibold text-gray-900">Comprar Casa</div>
          <div className="text-sm text-gray-600">Encontre o imóvel ideal</div>
        </Link>

        <Link
          to="/questionario-carros"
          className="border-2 border-orange-200 rounded-xl p-4 hover:border-orange-500 hover:bg-orange-50 transition text-center"
          onClick={onStoreSellerCode}
          data-testid="vendedor-service-carros-link"
        >
          <span className="text-4xl block mb-2">🚗</span>
          <div className="font-semibold text-gray-900">Comprar Carro</div>
          <div className="text-sm text-gray-600">Veículos seminovos</div>
        </Link>

        <Link
          to="/desenhar-planta"
          className="border-2 border-purple-200 rounded-xl p-4 hover:border-purple-500 hover:bg-purple-50 transition text-center"
          onClick={onStoreSellerCode}
          data-testid="vendedor-service-reforma-link"
        >
          <span className="text-4xl block mb-2">🏗️</span>
          <div className="font-semibold text-gray-900">Reforma</div>
          <div className="text-sm text-gray-600">Desenhe sua planta</div>
        </Link>
      </div>
    </div>
  );
};
